import { useEffect } from 'react';

/**
 * Sends the device orientation to Unity once the game has loaded, and again
 * every time it changes.
 *
 * Addresses Unity through the `screen.orientation` slot, so pass the bridged
 * `sendMessage` from `useUnityBridge`. Only mobile and tablet devices notify
 * Unity; desktop never does.
 *
 * @param {Object} options
 * @param {boolean} options.isLoaded - Whether the Unity game has finished loading.
 * @param {boolean} options.isMobileDevice - Whether the device is a mobile or tablet.
 * @param {'portrait'|'landscape'|null} options.orientation - Current device orientation.
 * @param {Function} options.sendMessage - Bridged `sendMessage` from `useUnityBridge`.
 */
export const useGameScreenOrientation = ({
    isLoaded,
    isMobileDevice,
    orientation,
    sendMessage,
}) => {
    useEffect(() => {
        if (!isLoaded || !isMobileDevice || !orientation) return;

        sendMessage('screen.orientation', orientation);
    }, [isLoaded, isMobileDevice, orientation, sendMessage]);
};
